// extracted by mini-css-extract-plugin
export default {"cls1":"lRumtv5S8D_nABUGK_RL","cls2":"r3PsbSXdlMGTBA4BtzSk lRumtv5S8D_nABUGK_RL"};